import { render } from "./WaterInfo.vue?vue&type=template&id=4b23d9ee"
import script from "./WaterInfo.vue?vue&type=script&lang=js"
export * from "./WaterInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__